import * as React from 'react';

export interface TableDockContextValue {
  /** Number of selected rows. Scopes the Actions menu and drives its badge. */
  selectedCount: number;
  /** True when the table is already its own window; hides the pop-out button. */
  isDetached: boolean;
}

const TableDockContext = React.createContext<TableDockContextValue | null>(
  null,
);

export const TableDockProvider = TableDockContext.Provider;

export const useTableDockContext = (
  component: string,
): TableDockContextValue => {
  const context = React.useContext(TableDockContext);
  if (!context) {
    throw new Error(`${component} must be used within a <TableDock>.`);
  }
  return context;
};
